import React from 'react'
import './code-selector.css'
import CodeSelectorButtons from './CodeSelectorButtons'

export const CodeSelector: React.FC = () => {
  return (
    <div className={'code-selector--container'} id="code-selector">
      <div className={'code-selector--wrapper'}>
        <CodeSelectorButtons />
      </div>
    </div>
  )
}
